import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import md5 from "crypto-js/md5";

/* global invsy */
import { set } from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    invsyUser: null,
    isIframe: false,
    login: false,
    points: 0,
    expressLaneValid: false,
    errorMessage: undefined,
    oneway: false,
    searchParameters: {
      pickupTime: undefined,
      dropoffTime: undefined,
      dropoffLocation: undefined,
      pickupLocation: undefined,
      country: undefined,
      carType: undefined,
    },
    priorSearch: false,
    priorSearchParams: {},
    cars: {
      all: [],
      filtered: [],
    },
    currentRateType: 0,
    driverDetails: {},
    payerDetails: {},
    reserveResponse: {},
    selectedCar: {},
    lastFilterOptions: undefined,
    lastDriverDetails: undefined,
    lastPayerDetails: undefined,
    lastCardDetails: undefined,
    lastFirstAdditionalDriver: undefined,
    lastSecondAdditionalDriver: undefined,
    isExtrasModalOpenOnMobile: false,
    flightDetails: null,
    isApiDown: false,
    apiErrorCode: 0,
  },
  mutations: {
    setApiDown(state, errorCode) {
      state.isApiDown = true;
      state.apiErrorCode = errorCode;
    },
    setApiHealthy(state) {
      state.isApiDown = false;
      state.apiErrorCode = 0;
    },
    //does not show the filter bar on mobile when the extras modal pops up
    updateIsExtrasModalOpenOnMobile(state, newValue) {
      state.isExtrasModalOpenOnMobile = newValue;
    },
    setLastDriverDetails(state, driverDetails) {
      state.lastDriverDetails = driverDetails;
    },
    setLastPayerDetails(state, payerDetails) {
      state.lastPayerDetails = payerDetails;
    },
    setLastCardDetails(state, cardDetails) {
      state.lastCardDetails = cardDetails;
    },
    setLastFirstAdditionalDriver(state, firstAdditionalDriver) {
      state.lastFirstAdditionalDriver = firstAdditionalDriver;
    },
    setLastSecondAdditionalDriver(state, secondAdditionalDriver) {
      state.lastSecondAdditionalDriver = secondAdditionalDriver;
    },
    setInvsyUser(state, user) {
      state.invsyUser = user;
      state.isIframe = true;
    },
    setPoints(state, points) {
      state.points = points;
    },
    checkLoginKey(state, loginKey) {
      const date = moment().format("YYYYMMDD_");
      const hash = md5(date);
      if (loginKey == hash.toString()) {
        state.login = true;
      } else {
        if (process.env.VUE_APP_REDIRECT_ON_NO_LOGIN_KEY == "true") {
          window.open("https://www.investectravel.com", "_self");
        } else {
          state.login = true;
        }
      }
    },
    setSearchParameters(state, searchParameters) {
      state.searchParameters = searchParameters.search;
      state.priorSearchParams = searchParameters.priorSearch;
      state.priorSearch = true;
      // check if valid express lane search by seeing if location is one of the express lane locations cpt jhb or dbh
      let validLocations = [
        "Cape Town International Airport, Cape Town, Western Cape",
        "OR Tambo International Airport, Johannesburg, Gauteng",
        "King shaka International Airport, Durban, KwaZulu-Natal",
      ];
      if (
        validLocations.some((substring) =>
          searchParameters.search.pickupLocation.locationName.includes(
            substring
          )
        )
      ) {
        state.expressLaneValid = true;
      } else {
        state.expressLaneValid = false;
      }
    },
    setOneway(state, value) {
      state.oneway = value;
    },
    setRateType(state, isSuper) {
      state.currentRateType = isSuper;
    },
    setCars(state, cars) {
      for (let car of cars) {
        car.key = generateSessionID();
      }
      state.cars.all = cars;
      state.cars.filtered = cars;
    },
    setDriverDetails(state, driverDetails) {
      state.driverDetails = driverDetails;
    },
    setPayerDetails(state, payerDetails) {
      state.payerDetails = payerDetails;
    },
    setSelectedCar(state, car) {
      state.selectedCar = car;
    },
    setReserveResponse(state, response) {
      state.reserveResponse = response;
    },
    setErrorMessage(state, errorMessage) {
      state.errorMessage = errorMessage;
    },
    setFlightDetails(state, flightDetails) {
      state.flightDetails = flightDetails;
    },
    // Check each car against the filter options
    filterCars(state, filterOptions) {
      state.lastFilterOptions = filterOptions;
      let carGroupsByType;
      switch (filterOptions.carType) {
        case "All":
          carGroupsByType = [
            "A",
            "B",
            "B1",
            "C2",
            "D",
            "E",
            "Z",
            "G",
            "G1",
            "G2",
            "M",
            "I",
            "Y",
            "Q",
            "K",
            "KM",
            "N",
            "TF",
            "O",
            "J",
            "H",
            "L",
            "N1",
            "N2"
          ];
          break;
        case "Economy":
          carGroupsByType = ["A", "B", "B1", "C2", "D", "E"];
          break;
        case "Luxury":
          carGroupsByType = ["Z", "G", "G1", "G2", "M"];
          break;
        case "Minivan":
          carGroupsByType = ["I", "Y", "Q", "O"];
          break;
        case "SUV":
          carGroupsByType = ["K", "KM", "N", "TF", "G1", "G2"];
          break;
        case "4x4":
          carGroupsByType = ["N1", "N2"];
          break;
        case "Light Trucks":
          carGroupsByType = ["H", "J", "P1"];
          break;
        default:
          carGroupsByType = [
            "A",
            "B",
            "B1",
            "C2",
            "D",
            "E",
            "Z",
            "G",
            "G1",
            "G2",
            "M",
            "I",
            "Y",
            "Q",
            "K",
            "KM",
            "N1",
            "N2",
            "L",
            "N",
            "TF",
            "H",
            "J",
            "O",
          ];
          break;
      }
      function groupFilter(car) {
        if (carGroupsByType.includes(car.group)) {
          return true;
        }
        return false;
      }
      function priceFilter(car) {
        if (
          (filterOptions.isSuper === "1" &&
            car.superDailyCharge < filterOptions.priceRange[0]) ||
          (filterOptions.isSuper === "1" &&
            car.superDailyCharge > filterOptions.priceRange[1]) ||
          (filterOptions.isSuper === "0" &&
            car.defaultDailyCharge < filterOptions.priceRange[0]) ||
          (filterOptions.isSuper === "0" &&
            car.defaultDailyCharge > filterOptions.priceRange[1]) ||
          (filterOptions.isSuper === "2" &&
            car.expressDailyCharge < filterOptions.priceRange[0]) ||
          (filterOptions.isSuper === "2" &&
            car.expressDailyCharge > filterOptions.priceRange[1])
        ) {
          return false;
        }
        return true;
      }
      function expressFilter(car) {
        if (
          filterOptions.isSuper === "2" &&
          (car.group == "M" || car.group == "Y" || car.group == "O" ||  isBakkie(car))
        ) {
          return false;
        }
        return true;
      }
      function isBakkie(car) {
        const bakkieGroups = ["H", "J", "I", "N1"];
        return bakkieGroups.includes(car.group);
      }
      function seatFilter(car) {
        if (
          car.seats < filterOptions.seatRange[0] ||
          car.seats > filterOptions.seatRange[1]
        ) {
          return false;
        }
        return true;
      }
      function doorFilter(car) {
        if (
          car.doors < filterOptions.doorRange[0] ||
          car.doors > filterOptions.doorRange[1]
        ) {
          return false;
        }
        return true;
      }
      function detailsFilter(car) {
        if (
          (car.details.airbags !== true && filterOptions.airbags === true) ||
          (car.details.ABS !== true && filterOptions.abs === true) ||
          (car.details.powerSteering !== true &&
            filterOptions.powersteering === true) ||
          (car.automatic !== true && filterOptions.automatic === true)
        ) {
          return false;
        }
        return true;
      }
      let tempFiltered = state.cars.all.filter(groupFilter);
      tempFiltered = tempFiltered.filter(expressFilter);
      tempFiltered = tempFiltered.filter(seatFilter);
      tempFiltered = tempFiltered.filter(doorFilter);
      tempFiltered = tempFiltered.filter(detailsFilter);
      tempFiltered = tempFiltered.filter(priceFilter);
      state.cars.filtered = tempFiltered;
    },
  },
  actions: {
    invsyLink({ state }, url) {
      if (state.isIframe) {
        invsy.platform.navigateUrl(url, "_blank");
      } else {
        window.open(url, "_blank");
      }
    },
    async initializeInvsy(context) {
      if (window !== window.parent) {
        invsy.platform.init();
        invsy.platform.initSession();

        try {
          // Get the points data
          const accounts = await invsy.api.privateClient.pbsa.accounts.list();
          let rewardsAvailableBalance = 0;
          if (accounts.result.RewardsAvailableBalance) {
            rewardsAvailableBalance = accounts.result.RewardsAvailableBalance;
          }
          if (typeof rewardsAvailableBalance !== "number") {
            rewardsAvailableBalance = Number(rewardsAvailableBalance);
          }
          context.commit("setPoints", rewardsAvailableBalance);

          // Get the user data
          //const res = await invsy.data.getAllUserContext();
          let clientData = {};
          //if (res.result.AuthResponse.authRes.IsMasqueradedAsClient) {
            clientData = await invsy.api.privateClient.pbsa.client.get();
            context.commit("setInvsyUser", clientData.result);
          //} else {
          //  clientData = await invsy.data.getClientBasicDetails();
          //  context.commit("setInvsyUser", clientData.result);
          //}

        } catch (error) {
          console.error("Failed to get user context:", error);
        }
      } else {
        console.log("not in iframe");
      }
      //invsy.platform.interactions.update({headerApp:{src:'https://example.com',show:true,height:'108'}})
    },
  },
});

// returns a session ID of n chunks eg 2; bu4adu2r-uis34yd1
function generateSessionID(n) {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  let sessionID = "";
  for (let i = 1; i < n; ++i) {
    sessionID += s4() + "-";
  }
  sessionID += s4();
  return sessionID;
}
